import { Layout as DefaultLayout } from 'react-admin'
import { AppBar } from './components/AppBar'

export const Layout = (props) => <DefaultLayout {...props} appBar={AppBar} />
